import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Navigation } from '../../navigation/react-redux-nav';
import { setConnectedProduct } from '../../store/ducks/connected-product';
import Icon, { NAMES } from '@ifit/react-icons';
import ConnectFilterCard from './components/connect-filter';
import ConnectModal from './components/connect-modal';
import LoginButton from '../../components/login-button';

import './index.css';

class ConnectSelectionPage extends Component {
  render() {
    return (
      <div className="connect-selection-page">
        <Navigation.Backward>
          <Icon
            className="back-arrow"
            name={ NAMES.ARROW_LEFT }
            color={ 'white' }
            size={ 24 }
            unitSize="px"
          />
        </Navigation.Backward>
        <LoginButton />
        <div className="content">
          <h1>Are you connecting to iFit wearable or mobile phone?</h1>

          <Navigation.Forward>
            <ConnectFilterCard
              title="Yes"
              subtitle="I plan on using an iFit wearable or mobile phone."
            />
          </Navigation.Forward>
          <Navigation.Forward onClick={ this.props.handleNoWearableSelected }>
            <ConnectFilterCard title="No" />
          </Navigation.Forward>

          <ConnectModal />
        </div>
      </div>
    );
  }
}

ConnectSelectionPage.propTypes = {
  handleNoWearableSelected: PropTypes.func.isRequired
};

export default connect(
  null,
  (dispatch) => {
    return {
      handleNoWearableSelected: () => dispatch(setConnectedProduct('other'))
    };
  }
)(ConnectSelectionPage);